import React, { CSSProperties, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from './Modal.module.scss';
import { CSSTransition } from "react-transition-group";
import XIcon from "../../Assets/SVG/XIcon";

interface Props {
    visible: boolean;
    onCancel?: () => void;
    title: string;
    subTitle?: string;
    children?: any;
    modalStyle?: CSSProperties;
    closeOnOutsideClick?: boolean;
}
const Modal = ({ visible, onCancel, title, subTitle, children, modalStyle, closeOnOutsideClick }: Props) => {
    
    useEffect(() => {
        if (closeOnOutsideClick) {
            const closeOnEscapeKeyDown = (e: any) => {
                if ((e.charCode || e.keyCode) === 27) {
                    if (visible && onCancel) {
                        onCancel()
                    }
                }
            };
    
            document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    
            return () => {
                document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
            }
        }
    }, [visible, onCancel, closeOnOutsideClick]);
    
    return createPortal(
        <CSSTransition
            in={visible}
            unmountOnExit
            timeout={{ enter: 0, exit: 300 }}
            classNames={{
                enterDone: styles.enterDone,
                enterActive: styles.enterActive,
                exit: styles.exit,
                exitActive: styles.exitActive
            }}
        >
            <div className={styles.modal} onMouseDown={() => {
                if (closeOnOutsideClick && onCancel) {
                    onCancel()
                }
            }}>
                <div className={styles.content} onMouseDown={e => e.stopPropagation()} style={modalStyle}>
                    <div className={styles.header}>
                        <div className={styles.heading}>
                            <span className={"h1"}>
                                {title}
                            </span>

                            {subTitle && (
                                <div className={styles.subtitle}>
                                    {subTitle}
                                </div>
                            )}
                        </div>
                        <XIcon onClick={onCancel} style={{cursor: 'pointer'}} />
                    </div>
                    <div className={styles.body}>
                        {children}
                    </div>
                </div>
            </div>
        </CSSTransition>
        , document.getElementById('root')!)
}

Modal.defaultProps = {
    closeOnOutsideClick: true
}

export default Modal
